import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'maintenance',
  components: {
    VueElementLoading,
    'vue-recaptcha': VueRecaptcha
  },
  props: [],
  data() {
  },
  computed: {

  },
  mounted() {

  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/views/components/maintenance/maintenance.component.js